import { motion } from "framer-motion";
import { LeftSection, RightSection } from "../header/Header.style";
import { WrapperHeroFour, TitleText } from "./Hero.styles";

const styles:any = {
  text:{
    lineHeight:"20px"
  },
}

export const HeroSectionFour = () => {
  return (
    <div style={{ background: "#fcfcfc", padding: "2rem 0" }}>
      <h1 style={{ marginLeft: "7%" }}>
        <TitleText style={{ marginBottom: "0px" }}>
          <div style={styles.text}>Kids & Teens finance and skills</div>
        </TitleText>
      </h1>
      <WrapperHeroFour>
        <LeftSection>
          <motion.div
            whileInView={{ x: 0, opacity:1 }}
            initial={{ x: "-100%", opacity: 0 }}
            transition={{ duration: 2, stiffness: 1 }}
          >
            <img
              src="img/Bonpellz (19) 1.jpg"
              style={{ height: "100%", width: "100%" }}
              alt=""
            />
          </motion.div>
        </LeftSection>

        <RightSection>
          <motion.div
            whileInView={{ x: 0, opacity: 1 }}
            initial={{ x: "100%", opacity: 0 }}
            transition={{ duration: 2, stiffness: 1 }}
          >
            <img
              src="img/Group 8554.jpg"
              style={{ height: "100%", width: "100%" }}
              alt=""
            />
          </motion.div>
        </RightSection>
      </WrapperHeroFour>
    </div>
  );
};
